export default __webpack_public_path__ + "static/media/Direction.84bc1b15.svg";